import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import MessageInputField from "./MessageInput";
import SendMessageButton from "./SendMessageButton";
import UploadImage from "./UploadImage";

const SendMessage = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors } = theme;
  return (
    <ET3Div
      width={1188}
      height={68}
      alignItems={"center"}
      fDirection={"row"}
      color={""}
      style={{
        backgroundColor: colors.all.paleGrayishWhite
      }}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <MessageInputField conversationID={conversationID} />
      <Et3Margin top={0} bottom={0} left={4} right={4} />
      <UploadImage conversationID={conversationID} />
      <Et3Margin top={0} bottom={0} left={4} right={4} />
      <SendMessageButton conversationID={conversationID} />
    </ET3Div>
  );
});

export default SendMessage;
